import moment from 'moment'
export const pickerOptions = {
  shortcuts: [
    {
      text: '今天',
      label: 'today',
      onClick(picker) {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime())
        picker.$emit('pick', [start, end])
      }
    },
    {
      text: '昨天',
      label: 'yestoday',
      onClick(picker) {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1)
        end.setTime(end.getTime() - 3600 * 1000 * 24 * 1)
        picker.$emit('pick', [start, end])
      }
    },
    {
      text: '最近7天',
      label: 'latest_7',
      onClick(picker) {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 6)
        picker.$emit('pick', [start, end])
      }
    },
    {
      text: '最近30天',
      label: 'latest_30',
      onClick(picker) {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 29)
        picker.$emit('pick', [start, end])
      }
    },
    {
      text: '本月至今',
      label: 'month',
      onClick(picker) {
        const end = new Date()
        const start = new Date()
        start.setDate(1)
        picker.$emit('pick', [start, end])
      }
    },
    {
      text: '上月',
      label: 'last_month',
      onClick(picker) {
        const end = new Date()
        const start = new Date()
        const month = start.getMonth()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
        picker.$emit('pick', [
          moment()
            .month(month - 1)
            .date(1),
          moment()
            .month(month - 1)
            .date(
              moment()
                .month(month - 1)
                .daysInMonth()
            )
        ])
      }
    },
    {
      text: '今年',
      label: 'year',
      onClick(picker) {
        const end = new Date()
        picker.$emit('pick', [moment(`${moment().year()}/01/01`), end])
      }
    }
  ]
}
export const changePickerLanguage = () => {
  pickerOptions.shortcuts = pickerOptions.shortcuts.map(item => {
    return  {
      ...item,
      text: window.$t(`system::time::text::${item.label}`, item.text)
    }
  })
}
